
import _ from 'lodash';

const $getSlugUrl = slug => {
  const baseUrl = process.env.VUE_APP_BASE_URL || `https://indeego.fr`;

  if (_.trim(slug).length) {
    return baseUrl.replace(/(https?:\/\/)(.*)/, `$1${slug}.$2`);
  }

  return ``;
};

const $getSlugUrlWithoutProtocol = slug => {
  const url = $getSlugUrl(slug);

  return url.replace(/https?:\/\//, ``);
};

export const getSlugUrl = {
  install(Vue) {
    Vue.prototype.$getSlugUrl = $getSlugUrl;
  },
};

export const getSlugUrlWithoutProtocol = {
  install(Vue) {
    Vue.prototype.$getSlugUrlWithoutProtocol = $getSlugUrlWithoutProtocol;
  },
};
